export function validMax(field) {
    return parseFloat(field.value) <= parseFloat(field.max);
}
